import chroma from "chroma-js";

/**
 * Sets the color for all the elements in an SVG.
 * @param {string} color - The color value in formats accepted in HTML/CSS (e.g., '#FFAABB', 'rgb(255,170,187)', 'red').
 * @param {boolean} forceFill - If true, will set the fill color for all elements, even if they don't have a fill attribute.
 * @param {Array<string>} ignoreColors - List of color values to be ignored when updating. Defaults to ['white'].
 * @returns {Function} A function that takes an SVG element as input and sets the color for all its elements.
 * @example
 *    <ReactSVG
 *      src={svg}
 *      beforeInjection={(svg) => {
 *        setSVGColor('currentColor', false, ['white', 'black'])(svg);
 *      }}
 *    />
 */
export const setSVGColor = (color, forceFill = false, ignoreColors = ["white"]) => {
    return (svg) => {
        const geometries = ["path", "circle", "rect", "ellipse", "line", "polyline", "polygon"];

        //checks if two color strings are equal regardless of format
        const colorEquals = (a, b) => {
            return chroma(a).hex() === chroma(b).hex();
        };

        geometries.forEach((geometry) => {
            svg.querySelectorAll(geometry).forEach((element) => {
                const fillColor = element.getAttribute("fill");
                const strokeColor = element.getAttribute("stroke");
                // Check if fill or stroke color exists in ignoreColors list
                if ((fillColor || forceFill) && !ignoreColors.some((x) => colorEquals(x, fillColor))) {
                    element.setAttribute("fill", color);
                }

                if (strokeColor && !ignoreColors.some((x) => colorEquals(x, strokeColor))) {
                    element.setAttribute("stroke", color);
                }
            });
        });
    };
};
